var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./exceeded-logs/exceeded-logs.module": [
		"./src/app/exceeded-logs/exceeded-logs.module.ts",
		"common",
		"exceeded-logs-exceeded-logs-module"
	],
	"./faculty/faculty.module": [
		"./src/app/faculty/faculty.module.ts",
		"common",
		"faculty-faculty-module"
	],
	"./institute/institute.module": [
		"./src/app/institute/institute.module.ts",
		"common",
		"institute-institute-module"
	],
	"./logs/logs.module": [
		"./src/app/logs/logs.module.ts",
		"common",
		"logs-logs-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"pages-pages-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./report/report.module": [
		"./src/app/report/report.module.ts",
		"common",
		"report-report-module"
	],
	"./slabs/slabs.module": [
		"./src/app/slabs/slabs.module.ts",
		"common",
		"slabs-slabs-module"
	],
	"./timetable/timetable.module": [
		"./src/app/timetable/timetable.module.ts",
		"common",
		"timetable-timetable-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;